import type { PlanRow } from "./contracts.js";
import type { z } from "zod";
import type { labelSourceIssueSchema } from "./work-order-request-contracts.js";

export const preparedWeek45Identity = {
  sha256: "7515e72ca9cdf7b29c0e96ddf6890383b0056ff1cc1bf16d5ab063f66dea8835",
  sheetName: "45. Hafta" as const,
  incompleteRows: [119, 120, 122] as const,
};

/** Exact prepared evidence only; unknown fields in legacy sources keep their existing policy. */
export function preparedSourceRequestIssues(sourceSha256: string, row: PlanRow): z.infer<typeof labelSourceIssueSchema>[] {
  if (sourceSha256 !== preparedWeek45Identity.sha256 || row.sheetName !== preparedWeek45Identity.sheetName
    || !preparedWeek45Identity.incompleteRows.some(number => number === row.rowNumber)) return [];
  const issues: z.infer<typeof labelSourceIssueSchema>[] = [];
  const fields = [
    { field: "workOrder", code: "SOURCE_FIELD_MISSING", label: "İş emri" },
    { field: "customerCode", code: "CUSTOMER_MISSING", label: "Müşteri kimliği" },
    { field: "orderNumber", code: "ORDER_NUMBER_MISSING", label: "Sipariş kimliği" },
  ] as const;
  for (const { field, code, label } of fields) if (!row[field]?.trim()) {
    issues.push({ code, field, severity: "blocking", message: `${label} eksik. Doğrulanmış iş emriyle devam edin.` });
  }
  return issues;
}
